import { render } from "./servicio.vue?vue&type=template&id=57fb2724&scoped=true"
import script from "./servicio.vue?vue&type=script&lang=js"
export * from "./servicio.vue?vue&type=script&lang=js"

import "./servicio.vue?vue&type=style&index=0&id=57fb2724&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57fb2724"]])

export default __exports__